import { ModalWindow, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import Block24Icon from './icons/block24.svg';
import * as styles from './BrokerAlreadyRegisteredModal.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BrokerAlreadyRegisteredModal = function BrokerAlreadyRegisteredModal(_ref) {
  var brokerName = _ref.brokerName,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose;
  return /*#__PURE__*/_jsx(ModalWindow, {
    content: /*#__PURE__*/_jsxs("div", {
      className: styles['content'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['icon'],
        children: /*#__PURE__*/_jsx("img", {
          src: Block24Icon
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['heading'],
        children: /*#__PURE__*/_jsx(UIHeading2, {
          textAlign: "center",
          children: "\u0412\u044B \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u0432\xA0\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435"
        })
      }), /*#__PURE__*/_jsxs(UIText1, {
        textAlign: "center",
        children: ["\u041F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442 ", brokerName, " \u043F\u043E\u0434 \u0441\u0432\u043E\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u044C\u044E \u0438\u043B\u0438\xA0\u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0443 \u0432\u0430\u0448\u0435\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438"]
      })]
    }),
    escape: true,
    fixed: false,
    onClose: onClose,
    open: isOpen,
    outside: true,
    print: true,
    size: "M",
    width: 648
  });
};